import { AdminApiClient } from '@guiker/property-sale-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useAdminApiClient = useAuthenticatedApiClient(AdminApiClient)
